import { updateQueryString } from '@iconik-io/core/src/url/update_query_string';
import { SearchHttpPostV2SearchNatural } from '@iconik-io/iconik-api/src/services/search';

import { SEARCH_PAGE_ROUTE } from '../../constants/routes';
import type { AppDispatch, GetState } from '../../store/types';
import { historyReplace } from '../history/actions';
import { httpCancelRequests } from '../http/actions';
import { NATURAL_SEARCH_QUERY_PARAM } from './constants';
import {
  selectIsNaturalSearchActive,
  selectIsNaturalSearchMode,
} from './selectors';
import { clearNaturalSearch } from './slice';

/**
 * Hands the search results back to the regular search: abandons any natural
 * search still in flight, drops the session and removes `natural_search` from
 * the URL, so a reload does not bring back a search the user moved away from.
 *
 * Leaves `searchFilters` and the result list alone, for the caller to refetch
 * with whatever the panel holds.
 */
export const endNaturalSearchSession =
  () =>
  (dispatch: AppDispatch, getState: GetState): void => {
    const state = getState();
    if (selectIsNaturalSearchActive(state)) {
      dispatch(httpCancelRequests([SearchHttpPostV2SearchNatural]));
      dispatch(clearNaturalSearch());
    } else if (
      // Regular mode ignores the param, so a link to a natural search keeps it.
      !selectIsNaturalSearchMode(state) ||
      state.routeParams.route !== SEARCH_PAGE_ROUTE
    ) {
      return;
    }

    // Clearing the query already dropped the session, but in AI mode the param
    // left behind would still run the search again on reload.
    const { pathname, search } = state.router.location;
    if (!new URLSearchParams(search).has(NATURAL_SEARCH_QUERY_PARAM)) {
      return;
    }
    dispatch(
      historyReplace(
        `${pathname}${updateQueryString(search, {
          [NATURAL_SEARCH_QUERY_PARAM]: null,
        })}`,
      ),
    );
  };
